import BreedsService from "../../api/breeds.service";

const state = {};

const getters = {};

const actions = {
	async getBreeds({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await BreedsService.getBreeds(authToken);
		return response;
	},
    async addBreed({ rootState }, request) {
		const { authToken } = rootState.auth;
		const response = await BreedsService.addBreed(authToken, request);
		return response;
	},
    async editBreed({ rootState }, request) {
		const { authToken } = rootState.auth;
		const response = await BreedsService.editBreed(authToken, request);
		return response;
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
